// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__env-switcher___2qP_X {
    margin: 0 20px 30px;
  }
  /* modal trigger */
  .DefaultTheme__env-button___3ZADX {
    --_apc-env-switcher-button-border-radius: var(--_apc-env-switcher-button-border-radius-lume, 4px);
    --_apc-env-switcher-button-box-shadow: var(--_apc-env-switcher-button-box-shadow-lume, 0 1px 2px rgba(0,0,0,.075));

    background-color: var(--tertiary);
    border: 1px solid var(--_apc-env-switcher-button-border, var(--aluminum2));
    border-radius: var(--_apc-env-switcher-button-border-radius);
    box-shadow: var(--_apc-env-switcher-button-box-shadow);
    color: inherit;
    cursor: pointer;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    overflow: hidden;
    padding-bottom: 0;
    padding-top: 0;
    text-align: center;
    text-overflow: ellipsis;
    transition: background-color .15s cubic-bezier(.46,.03,.52,.96), border-color .15s cubic-bezier(.46,.03,.52,.96), box-shadow .15s cubic-bezier(.46,.03,.52,.96);
    white-space: nowrap;
    width: 100%;
  }
  .DefaultTheme__env-button___3ZADX:hover {
      background-color: var(--_apc-env-switcher-button-hover-background-color, var(--aluminum1));
      box-shadow: none;
    }
  .DefaultTheme__env-button___3ZADX:active {
      background-color: var(--_apc-env-switcher-button-active-background-color, var(--aluminum1));
      box-shadow: none;
      color: var(--_apc-env-switcher-button-active-color, var(--aluminum5));
      fill: currentColor;
    }
  /* modal */
  .DefaultTheme__modal___3OWrQ {
    max-width: 600px;
    overflow: auto;
  }
  .DefaultTheme__modal-body___1cW23 {
    padding-left: 0;
    padding-right: 0;
  }
  .DefaultTheme__modal-footer___2GYTs {
    align-items: center;
    display: flex;
    justify-content: space-between;
    text-align: left;
  }
  .DefaultTheme__env-item___FPywS {
    align-items: center;
    background: none;
    border: 0;
    color: var(--_apc-env-switcher-item-color, var(--steel4));
    display: flex;
    height: 40px;
    outline: none;
    padding: 0 40px;
    text-align: left;
    width: 100%;
  }
  .DefaultTheme__env-item___FPywS:hover {
      background-color: var(--_apc-env-switcher-item-hover-background-color, var(--aluminum1));
    }
  .DefaultTheme__env-item___FPywS:active, .DefaultTheme__env-item___FPywS.DefaultTheme__active___nMdTR {
      --_apc-env-switcher-item-active-color: var(--_apc-env-switcher-mark-active-color, inherit);

      color: var(--_apc-env-switcher-item-active-color);
      background-color: var(--_apc-env-switcher-item-active-background-color, var(--aluminum2));
    }
  .DefaultTheme__no-env-message___1nd9A {
    color: var(--aluminum5);
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    padding: 0 40px;
  }
  .DefaultTheme__env-item-title___1w9lG {
    display: block;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /* indicators for active/default state */
  .DefaultTheme__mark___3FR7b {
    font-size: 14px;
    margin-left: 10px;
  }
  .DefaultTheme__mark-active___1cWRk {
    --_apc-env-switcher-mark-active-font-weight: var(--_apc-env-switcher-mark-active-font-weight-lume, 400);

    color: var(--_apc-env-switcher-mark-active-color, var(--core-blue3));
    font-weight: var(--_apc-env-switcher-mark-active-font-weight);
  }
  .DefaultTheme__mark-default___w9TNi {
    color: var(--aluminum5);
  }
  .DefaultTheme__anchor___D3-41 {
    --_apc-env-switcher-anchor-text-decoration: var(--_apc-env-switcher-anchor-text-decoration-lume, none);

    font-size: 12px;
    margin-right: 20px;
    color: var(--primary);
    -webkit-text-decoration: var(--_apc-env-switcher-anchor-text-decoration);
            text-decoration: var(--_apc-env-switcher-anchor-text-decoration);
  }
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/platform-components/EnvSwitcher/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;EACrB;EACA,kBAAkB;EAClB;IACE,iGAAiG;IACjG,kHAAkH;;IAElH,iCAAiC;IACjC,0EAA0E;IAC1E,4DAA4D;IAC5D,sDAAsD;IACtD,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,+JAA+J;IAC/J,mBAAmB;IACnB,WAAW;EACb;EACA;MACI,0FAA0F;MAC1F,gBAAgB;IAClB;EACF;MACI,2FAA2F;MAC3F,gBAAgB;MAChB,qEAAqE;MACrE,kBAAkB;IACpB;EACF,UAAU;EACV;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,yDAAyD;IACzD,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;MACI,wFAAwF;IAC1F;EACF;MACI,0FAA0F;;MAE1F,iDAAiD;MACjD,yFAAyF;IAC3F;EACF;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA,wCAAwC;EACxC;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,uGAAuG;;IAEvG,oEAAoE;IACpE,6DAA6D;EAC/D;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sGAAsG;;IAEtG,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,wEAAwE;YAChE,gEAAgE;EAC1E","sourcesContent":[".DefaultTheme__env-switcher___2qP_X {\n    margin: 0 20px 30px;\n  }\n  /* modal trigger */\n  .DefaultTheme__env-button___3ZADX {\n    --_apc-env-switcher-button-border-radius: var(--_apc-env-switcher-button-border-radius-lume, 4px);\n    --_apc-env-switcher-button-box-shadow: var(--_apc-env-switcher-button-box-shadow-lume, 0 1px 2px rgba(0,0,0,.075));\n\n    background-color: var(--tertiary);\n    border: 1px solid var(--_apc-env-switcher-button-border, var(--aluminum2));\n    border-radius: var(--_apc-env-switcher-button-border-radius);\n    box-shadow: var(--_apc-env-switcher-button-box-shadow);\n    color: inherit;\n    cursor: pointer;\n    font-size: inherit;\n    height: 40px;\n    line-height: 40px;\n    outline: none;\n    overflow: hidden;\n    padding-bottom: 0;\n    padding-top: 0;\n    text-align: center;\n    text-overflow: ellipsis;\n    transition: background-color .15s cubic-bezier(.46,.03,.52,.96), border-color .15s cubic-bezier(.46,.03,.52,.96), box-shadow .15s cubic-bezier(.46,.03,.52,.96);\n    white-space: nowrap;\n    width: 100%;\n  }\n  .DefaultTheme__env-button___3ZADX:hover {\n      background-color: var(--_apc-env-switcher-button-hover-background-color, var(--aluminum1));\n      box-shadow: none;\n    }\n  .DefaultTheme__env-button___3ZADX:active {\n      background-color: var(--_apc-env-switcher-button-active-background-color, var(--aluminum1));\n      box-shadow: none;\n      color: var(--_apc-env-switcher-button-active-color, var(--aluminum5));\n      fill: currentColor;\n    }\n  /* modal */\n  .DefaultTheme__modal___3OWrQ {\n    max-width: 600px;\n    overflow: auto;\n  }\n  .DefaultTheme__modal-body___1cW23 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .DefaultTheme__modal-footer___2GYTs {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    text-align: left;\n  }\n  .DefaultTheme__env-item___FPywS {\n    align-items: center;\n    background: none;\n    border: 0;\n    color: var(--_apc-env-switcher-item-color, var(--steel4));\n    display: flex;\n    height: 40px;\n    outline: none;\n    padding: 0 40px;\n    text-align: left;\n    width: 100%;\n  }\n  .DefaultTheme__env-item___FPywS:hover {\n      background-color: var(--_apc-env-switcher-item-hover-background-color, var(--aluminum1));\n    }\n  .DefaultTheme__env-item___FPywS:active, .DefaultTheme__env-item___FPywS.DefaultTheme__active___nMdTR {\n      --_apc-env-switcher-item-active-color: var(--_apc-env-switcher-mark-active-color, inherit);\n\n      color: var(--_apc-env-switcher-item-active-color);\n      background-color: var(--_apc-env-switcher-item-active-background-color, var(--aluminum2));\n    }\n  .DefaultTheme__no-env-message___1nd9A {\n    color: var(--aluminum5);\n    font-size: 14px;\n    height: 40px;\n    line-height: 40px;\n    padding: 0 40px;\n  }\n  .DefaultTheme__env-item-title___1w9lG {\n    display: block;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  /* indicators for active/default state */\n  .DefaultTheme__mark___3FR7b {\n    font-size: 14px;\n    margin-left: 10px;\n  }\n  .DefaultTheme__mark-active___1cWRk {\n    --_apc-env-switcher-mark-active-font-weight: var(--_apc-env-switcher-mark-active-font-weight-lume, 400);\n\n    color: var(--_apc-env-switcher-mark-active-color, var(--core-blue3));\n    font-weight: var(--_apc-env-switcher-mark-active-font-weight);\n  }\n  .DefaultTheme__mark-default___w9TNi {\n    color: var(--aluminum5);\n  }\n  .DefaultTheme__anchor___D3-41 {\n    --_apc-env-switcher-anchor-text-decoration: var(--_apc-env-switcher-anchor-text-decoration-lume, none);\n\n    font-size: 12px;\n    margin-right: 20px;\n    color: var(--primary);\n    -webkit-text-decoration: var(--_apc-env-switcher-anchor-text-decoration);\n            text-decoration: var(--_apc-env-switcher-anchor-text-decoration);\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
